import React from 'react';
import Balancer from 'react-wrap-balancer';

interface OnboardingWrapperProps {
  children: React.ReactNode;
  heading: string;
  subHeading?: string | null;
  email?: string | null;
}

const OnboardingWrapper = ({
  children,
  heading,
  subHeading,
  email,
}: OnboardingWrapperProps) => {
  return (
    <div className="flex flex-col w-full text-center px-6">
      <div className="mb-5">
        <h2 className="text-xl mb-1.5">
          <Balancer>{heading}</Balancer>
        </h2>
        {subHeading && (
          <p className="text-sm text-textGray">
            <Balancer>
              {email &&
                subHeading.split(email).map((part, index) => (
                  <React.Fragment key={`${part}-${email}`}>
                    {part}
                    {index < subHeading.split(email).length - 1 && (
                      <strong>{email}</strong>
                    )}
                  </React.Fragment>
                ))}
            </Balancer>
          </p>
        )}
      </div>
      {children}
      <div className="text-sm text-textGray4 mt-6 text-center">
        Join 2M+ researchers
      </div>
    </div>
  );
};

export default OnboardingWrapper;
